/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationsControllerFindOneQueryResponse, NotificationsControllerFindOnePathParams, NotificationsControllerFindOneQueryParams, NotificationsControllerFindOne400, NotificationsControllerFindOne401, NotificationsControllerFindOne403, NotificationsControllerFindOne404 } from "../../models/notificationsController/NotificationsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { notificationsControllerFindOne } from "../../clients/notificationsService/notificationsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const notificationsControllerFindOneQueryKey = (id: NotificationsControllerFindOnePathParams["id"], params: NotificationsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/notifications/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type NotificationsControllerFindOneQueryKey = ReturnType<typeof notificationsControllerFindOneQueryKey>;
export function notificationsControllerFindOneQueryOptions(id: NotificationsControllerFindOnePathParams["id"], params?: NotificationsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = notificationsControllerFindOneQueryKey(id, params);
  return queryOptions<NotificationsControllerFindOneQueryResponse, ResponseErrorConfig<NotificationsControllerFindOne400 | NotificationsControllerFindOne401 | NotificationsControllerFindOne403 | NotificationsControllerFindOne404>, NotificationsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return notificationsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @description Retrieve a single notification. User can only access their own notifications.
 * @summary Get a notification by ID
 * {@link /api/v1/notifications/:id}
 */
export function useNotificationsControllerFindOne<TData = NotificationsControllerFindOneQueryResponse, TQueryData = NotificationsControllerFindOneQueryResponse, TQueryKey extends QueryKey = NotificationsControllerFindOneQueryKey>(id: NotificationsControllerFindOnePathParams["id"], params?: NotificationsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<NotificationsControllerFindOneQueryResponse, ResponseErrorConfig<NotificationsControllerFindOne400 | NotificationsControllerFindOne401 | NotificationsControllerFindOne403 | NotificationsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? notificationsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...notificationsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<NotificationsControllerFindOne400 | NotificationsControllerFindOne401 | NotificationsControllerFindOne403 | NotificationsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}